import { ViewResolver } from '@Components/index';

import DesktopLayout from './desktop/DesktopLayout';
import MobileLayout from './mobile/MobileLayout';
import useDictionaryLoader from './hooks/useDictionaryLoader';

interface MaterialRequestLayoutProps {
  children: JSX.Element | JSX.Element[];
}

const MaterialRequestLayout: React.FC<MaterialRequestLayoutProps> = ({
  children,
}) => {
  useDictionaryLoader();

  return (
    <ViewResolver
      desktop={<DesktopLayout>{children}</DesktopLayout>}
      mobile={<MobileLayout>{children}</MobileLayout>}
    />
  );
};

export default MaterialRequestLayout;
